import { getTemplateAssetRefs } from "./templateAssetRegistry";

export function getLibraryAssetRoleGuess(asset) {
  const tags = [
    ...(asset?.usage_tags || []),
    ...(asset?.style_tags || []),
    asset?.name || "",
    asset?.asset_type || "",
  ]
    .join(" ")
    .toLowerCase();

  if (tags.includes("ganesha") && tags.includes("background")) return "ganesha_hero_background";
  if (tags.includes("ganpati") && tags.includes("background")) return "ganesha_hero_background";
  if (tags.includes("marigold") || tags.includes("garland")) return "marigold_frame";
  if (tags.includes("diya") || tags.includes("lamp") || tags.includes("glow")) return "diya_glow_overlay";
  if (tags.includes("modak")) return "modak_icon";
  if (tags.includes("lotus")) return "lotus_divider";
  if (tags.includes("ganesha") || tags.includes("ganpati")) return "ganesha_icon_or_silhouette";
  if (tags.includes("arch")) return "royal_arch";
  if (tags.includes("mandala")) return "mandala_centerpiece";
  if (tags.includes("divider")) return "divider_ornament";
  if (tags.includes("paisley") || tags.includes("corner")) return "paisley_corner";
  if (tags.includes("floral") || tags.includes("flower")) return "floral_cluster";
  if (tags.includes("sparkle")) return "sparkle_overlay";
  if (tags.includes("background")) return "hero_background";
  return "decorative_asset";
}

export function getCreativeBriefPalette(form) {
  return {
    primary: form.palette_primary,
    secondary: form.palette_secondary,
    accent: form.palette_accent,
    background: form.palette_background,
    text: form.palette_text_color,
  };
}

export function mapRegistryAssetToCreatePayload(asset) {
  return {
    family_id: asset.familyId,
    spec_id: asset.specId,
    asset_key: asset.assetKey,
    role: asset.role,
    display_name: asset.displayName,
    asset_type: asset.type,
    source_strategy: asset.sourceStrategy,
    status: asset.src ? (asset.sourceStrategy === "generate" ? "needs_review" : "available") : "planned",
    is_required: Boolean(asset.required),
    is_reusable: Boolean(asset.reusable),
    description: asset.description || "",
    prompt_reference: asset.promptReference || "",
    generation_prompt: asset.generationPrompt || "",
    negative_prompt: asset.negativePrompt || "",
    asset_tag_query: asset.assetTagQuery || [],
    scene_usage: asset.sceneUsage || [],
    storage_path: asset.storagePath || "",
    file_url: asset.src || null,
    thumbnail_url: null,
    polotno_mapping: asset.polotnoMapping || null,
    asset_metadata: {
      seeded_from_registry: true,
      is_placeholder: Boolean(asset.placeholder),
      editable: asset.editable !== false,
    },
  };
}

export function getTemplateAssetSrc(assetRefs, role) {
  return assetRefs[role]?.src || "";
}

export function getRegistryAssetPreviewUrl(asset) {
  if (asset?.thumbnail_url || asset?.file_url) {
    return asset.thumbnail_url || asset.file_url;
  }

  const registryAsset = getTemplateAssetRefs(asset?.family_id)?.[asset?.role];
  return registryAsset?.src || "";
}
